import * as React from "react";
import { Button, Modal } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { AgGridReact } from "ag-grid-react";
import { ColDef } from "ag-grid-community";
import { useToast } from "../../core/contexts/toast";
import { FilterCatalogoPrecoBase } from "../../core/repositories/CatalagoPrecoBaseRepositorio";
import { AG_GRID_LOCALE_BR } from "../../core/config/AgGridReact";
import moment from "moment";
import "./index.scss";
import { TipoFormatacao } from "../../core/config/tipoFormatacao";
import { CatalogoPrecoBaseModel, CatalogoPrecoBaseModelGranularidade } from "../../core/models/catalagoPrecoBase";
import { OrdemCompraModel } from "../../core/models/ordemCompra";
import { FilterOrdemCompra, OrdemCompraRepositorio } from "../../core/repositories/ordemCompraRepositorio";
import { formatarDecimal } from "../../core/utils/funcoes";
import { useTranslation } from "react-i18next";

interface Props {
  show: boolean;
  data?: CatalogoPrecoBaseModel;
  search: FilterCatalogoPrecoBase;
  subTitle?: string;
  onHide: () => void;
}

export const ModalBuyers: React.FC<Props> = (props) => {
  const [loading, setLoading] = React.useState(true);
  const [title, setTitle] = React.useState<string>("");
  const gridRef = React.useRef<AgGridReact<CatalogoPrecoBaseModel>>(null);

  const [rowData, setRowData] = React.useState<OrdemCompraModel[]>([]);
  const { mostrarToast } = useToast();
  const { t } = useTranslation();
  
  React.useEffect(() => {
    setLoading(true);
    console.log(props.data);
    if (props.show && props.data) {
      showLoadingOverlay();
      setRowData(Array.from({ length: 20 }, () => new OrdemCompraModel()));

      if (props.data.num_level === 5) {
        setTitle(props.data.product_code + " - " + (props.data as any)[CatalogoPrecoBaseModelGranularidade.DESCRICAO[props.data.num_level]]?.toString());
      } else {
        setTitle((props.data as any)[CatalogoPrecoBaseModelGranularidade.DESCRICAO[props.data.num_level]]?.toString());
      }

      const filter = new FilterOrdemCompra();
      filter.branch_code = props.data.branch_code;
      filter.category_code = props.data.category_code;
      filter.subcategory_code = props.data.subcategory_code;
      filter.department_code = props.data.department_code;
      filter.mesorregion_code = props.data.mesorregion_code;
      filter.product_code = props.data.product_code;
      filter.year_week = props.search.year_week;

      console.log(filter);

      new OrdemCompraRepositorio()
        .getFilter(filter, "_post")
        .then((res) => {
          setRowData(res ? res : []);
        })
        .catch(() => {
          setRowData([]);
          mostrarToast({
            titulo: "Erro",
            mensagem: t("pages.Aconteceu algo inesperado, por favor tente novamente mais tarde!"),
            tipo: "error",
          });
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [props.show, props.data]);

  const CustomSkeleton = (props: { value: any; money?: boolean; date?: boolean }) => {
    return (
      <>
        {loading ? (
          <Skeleton />
        ) : props.date ? (
          moment(props.value).format(TipoFormatacao.FORMATO_DATA)
        ) : typeof props.value === "number" ? (
          formatarDecimal(props.value, props.money)
        ) : (
          props.value
        )}
      </>
    );
  };
  const columnDefs: ColDef[] = [
    {
      headerName: "Fornecedor",
      field: "supplier_code",
      minWidth: 200,
      flex: 1,
      floatingFilter: true,
      filter: "agTextColumnFilter",
      resizable: false,
      cellRenderer: CustomSkeleton,
    },
    {
      headerName: "Produto",
      field: "product_description",
      minWidth: 350,
      flex: 2,
      floatingFilter: true,
      filter: "agTextColumnFilter",
      resizable: false,
      cellRenderer: CustomSkeleton,
    },
    {
      headerName: "Data da Compra",
      field: "date_update",
      // valueFormatter: (params: { value: string }) => {
      //   const date = new Date(params.value);
      //   const day = date.getDate().toString().padStart(2, "0");
      //   const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero based
      //   const year = date.getFullYear();
      //   return `${day}/${month}/${year}`;
      // },
      minWidth: 180,
      flex: 1,
      floatingFilter: true,
      filter: "agDateColumnFilter",
      resizable: false,
      cellRenderer: (params: any) => <CustomSkeleton value={params.value} date={true} />,
    },
    {
      headerName: "Quantidade",
      field: "total_quantity",
      minWidth: 100,
      flex: 1,
      floatingFilter: true,
      filter: "agNumberColumnFilter",
      resizable: false,
      cellRenderer: CustomSkeleton,
    },
    {
      headerName: "Preço",
      field: "unit_price",
      minWidth: 100,
      flex: 1,
      floatingFilter: true,
      filter: "agNumberColumnFilter",
      resizable: false,
      cellRenderer: (params: any) => <CustomSkeleton value={params.value} money={true} />,
    },
    {
      headerName: "Total",
      field: "order_value",
      minWidth: 100,
      flex: 1,
      floatingFilter: true,
      filter: "agNumberColumnFilter",
      resizable: false,
      cellRenderer: (params: any) => <CustomSkeleton value={params.value} money={true} />,
    },
  ];

  function showLoadingOverlay() {
    if (props.show && gridRef.current && gridRef.current.api) {
      gridRef.current.componentDidUpdate = () => {
        if (loading && gridRef.current && gridRef.current.api) {
          gridRef.current.api.showLoadingOverlay();
        } else if (gridRef.current && gridRef.current.api) {
          gridRef.current.api.hideOverlay();
        }
      };
    }
  }

  return (
    <>
      <Modal centered aria-labelledby="contained-modal-title-vcenter" size="xl" {...props}>
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter" className="text-center">
            Pedidos de compras: {title}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="ag-theme-quartz w-100" style={{ height: 500 }}>
            <AgGridReact
              ref={gridRef}
              rowData={rowData}
              gridId="modalBuyers"
              columnDefs={columnDefs}
              embedFullWidthRows={true}
              pagination={true}
              paginationPageSize={20}
              localeText={AG_GRID_LOCALE_BR}
              overlayLoadingTemplate='<span class="">Carregando...</span>'
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="success"
            onClick={() => {
              props.onHide();
            }}
          >
            Fechar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};


